module.exports = __webpack_public_path__ + "static/media/authereum.f277665b.png";